import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ReportStatusBadge } from '$features/report-hub/components/report-status-badge';
import type { RunRecordReportDetailModel } from '$features/report-hub/run-record/run-record-detail.types';

interface RunRecordSidecarHeaderProps {
  report?: RunRecordReportDetailModel;
}

export function RunRecordSidecarHeader({
  report,
}: RunRecordSidecarHeaderProps): ReactElement {
  const { t } = useTranslation();

  return (
    <div className="sidecar__masthead m-bottom-xl">
      <div className="sidecar__device-detail-header gap-m">
        <h2 className="font-weight-bold font-size-xxl">{t('runRecordDetail.title')}</h2>
        {report && <ReportStatusBadge status={report.status} bordered />}
      </div>
    </div>
  );
}
